import { RestoreableModel, ResourceFactory } from '../services/';

class Result extends RestoreableModel {
  public sample: {
    id: number;
    date: string;
    time: string;
    depth: number;
    station: {
      id: number;
      name: string;
    };
    campaign: {
      id: number;
      name: string;
    };
  } = null; 

  public parameter: {
    id: number;
    name: string;
    decimals: number;
    unit: string;
  } = null;

  public value:                number;
  public description:          string;
  public extra_value:          number;
  public extra_description:    string;
  public minvalue:             number;
  public maxvalue:             number;
  public replicates:           number;
  public detection_limit:      number;
}

const ResultFactory = ResourceFactory.create<Result>(Result, 'result');

export { Result, ResultFactory };
